// extracted by mini-css-extract-plugin
export default {"sidebar-col":"Layout_sidebar-col__Tur30","collapsed":"Layout_collapsed__I-TLc","layoutContainer":"Layout_layoutContainer__RlSXd","mainWrapper":"Layout_mainWrapper__ms70g"};